export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20manga%20style%20illustration%20with%20warm%20crimson%20and%20amber%20gradient%20background%2C%20abstract%20brush%20stroke%20texture%2C%20Japanese%20comic%20panel%20silhouettes%2C%20dramatic%20lighting%2C%20artistic%20ink%20wash%20effect%2C%20dark%20atmospheric%20mood%20with%20warm%20highlights%2C%20no%20text%2C%20no%20characters%2C%20abstract%20expressionist%20style&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          onError={(e) => {
            (e.target as HTMLElement).parentElement!.style.display = 'none';
          }}
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>

      <div className="relative w-full z-10 px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left w-full">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-300 text-xs md:text-sm font-medium mb-5 whitespace-nowrap">
              刃牙漫画下拉式全集
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading text-white leading-tight mb-4">
              刃牙漫画 - 热血格斗漫画免费在线阅读平台
            </h1>

            <p className="text-base md:text-lg text-white/70 leading-relaxed max-w-xl mx-auto lg:mx-0">
              无需下载，流畅浏览全部章节
            </p>

            <p className="text-sm md:text-base text-white/60 leading-relaxed max-w-xl mx-auto lg:mx-0 mt-5">
              刃牙漫画在线观看平台为您提供完整的刃牙系列免费阅读体验。涵盖刃牙、刃牙道、范马刃牙等全部篇章，采用下拉式排版，一滑到底，沉浸式畅读。每日同步更新最新话，热门篇章一网打尽，是格斗漫画爱好者的首选在线阅读站。
            </p>

            <div className="flex flex-wrap items-center gap-5 md:gap-8 mt-6 justify-center lg:justify-start">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-primary-500/15">
                  <i className="ri-book-open-line text-primary-400 text-base"></i>
                </div>
                <div className="text-left">
                  <div className="text-white font-semibold text-sm md:text-base">200+</div>
                  <div className="text-white/50 text-xs">话持续更新</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-accent-500/15">
                  <i className="ri-group-line text-accent-400 text-base"></i>
                </div>
                <div className="text-left">
                  <div className="text-white font-semibold text-sm md:text-base">58万+</div>
                  <div className="text-white/50 text-xs">漫友在线</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-secondary-500/15">
                  <i className="ri-shield-check-line text-secondary-400 text-base"></i>
                </div>
                <div className="text-left">
                  <div className="text-white font-semibold text-sm md:text-base">高清无广告</div>
                  <div className="text-white/50 text-xs">纯净阅读</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-4 mt-8 justify-center lg:justify-start">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-full font-medium text-sm md:text-base transition-colors whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始阅读
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-7 py-3 border border-white/30 hover:border-white/60 text-white rounded-full font-medium text-sm md:text-base transition-colors whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-fire-line text-lg"></i>
                人气排行
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-[320px] sm:max-w-[380px] md:max-w-[420px] lg:max-w-[460px]">
            <div className="relative aspect-[3/4] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Epic%20fighting%20manga%20style%20illustration%20silhouette%20with%20intense%20combat%20pose%2C%20dramatic%20brush%20ink%20effect%2C%20warm%20red%20and%20orange%20gradient%20background%2C%20Japanese%20comic%20aesthetic%2C%20dynamic%20action%20lines%2C%20powerful%20energy%20burst%2C%20bold%20composition%2C%20no%20text%2C%20abstract%20martial%20arts%20theme&width=900&height=1200&seq=hero-main-2026&orientation=portrait"
                alt="刃牙漫画 - 热血格斗漫画免费在线阅读平台"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).parentElement!.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}